import Enterprise from "./LegacyEnterprise";

export default Enterprise;
